export default __webpack_public_path__ + "static/media/alertTwo.da9925b5.mp3";